import styled from 'styled-components';

export const AboutFinderContainer = styled.div`
  padding: 20px 10px 0;
  background: #fff;
`;

export const BabyNameTitle = styled.h1`
  font-size: 18px;
  padding: 14px 8px 0;
  font-weight: 500;
  color: hsl(0deg 0% 0% / 83%);
`;

export const ImageStyle = styled.div`
  position: relative;

  & div {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 30px;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0), #fff);
  }
`;

export const NameFinderImage = styled.img`
  width: 100%;
  height: clamp(140px, 20vw, 300px);
  object-fit: cover;
  border-radius: 8px;
`;

export const NameFinderDesc = styled.p`
  font-size: 13px;
  color: #000;
  padding: 10px 8px;
`;

export const Wrapper = styled.div`
  width: 100%;
  margin: 0 auto;
  // padding-top: ${(props) => (props.noCategory ? '80px' : '122px')};
  padding-top: ${(props) => (props.extraPadding ? ' 56px' : '10%')};
  background: #fff;

  @media (max-width: 720px) {
    margin: ${(props) => (props.extraMargin ? '56px auto 0' : '0 auto')};
    padding-top: 0;
  }
`;

export const BabyFinderContainer = styled.div`
  @media (min-width: 720px) {
    padding: ${(props) => (props.forAds ? '0 5%' : '')};
    display: ${(props) => (props.forAds ? 'flex' : '')};
    gap: ${(props) => (props.forAds ? '2%' : '')};
  }
  width: 100%;
  max-width: ${(props) => (props.forAds ? '' : '860px')};
  margin: ${(props) => (props.forAds ? '' : 'auto')};
`;
export const AdsCover = styled.div`
  @media (max-width: 720px) {
    display: none;
  }
  min-width: 20%;
`;
